module.exports = __webpack_public_path__ + "static/media/pharmaflexrx-bonus-package.e51934e4.png";